import { render, staticRenderFns } from "./HuntingWords.vue?vue&type=template&id=4d25f344&scoped=true&"
import script from "./HuntingWords.vue?vue&type=script&lang=js&"
export * from "./HuntingWords.vue?vue&type=script&lang=js&"
import style0 from "./HuntingWords.vue?vue&type=style&index=0&id=4d25f344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25f344",
  null
  
)

export default component.exports